// Blocks whose value the server stamps at signing time, from the same timestamp it writes to
// `signature.signedAt`. The signer must never be handed a control for one: whatever they enter is
// discarded by the server, so an editable field only invites them to set a date that silently does
// not survive to the finished document.
//
// Two block types qualify:
//   - `signingDate`                      — read-only by design.
//   - `date` with `autofillSigningDate`  — the legacy shape, kept working for templates built
//                                          before `signingDate` existed.
//
// Mirrored in the main app at `core/imports/esignature/blocks.js`. The two repos share no package,
// so a change here has to be made there too.
export const isAutoFilledBlock = (block) =>
  block?.type === 'signingDate' || (block?.type === 'date' && block?.autofillSigningDate === true);

// The zone abbreviation for an instant, resolved from the instant itself.
//
// date-fns-tz's `zzz` token derives it from the already-shifted wall-clock date, which lands on
// the wrong side of a DST transition (2026-11-01T07:30:00Z in America/New_York prints `EDT` when
// the instant is `EST`). The main app resolves the label through this same Intl call, so a
// timestamp shown here and the one printed on the finished PDF always read identically.
export const zoneLabel = (date, timezone) =>
  new Intl.DateTimeFormat('en-US', { timeZone: timezone, timeZoneName: 'short' })
    .formatToParts(date)
    .find((part) => part.type === 'timeZoneName')?.value || '';
